export const APP_ROOT_AA_EXP_CONFIG = {
  group: 'app-root-aa-experiment',
  name: 'aa-experiment',
}
